import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input, OnChanges,
  OnInit,
  Output, SimpleChanges,
  ViewChild
} from '@angular/core';
import {NgClass, NgForOf, NgIf} from '@angular/common';
import {ImageSliderComponent} from '../horizontal-slider/image-slider/image-slider.component';
import {TextsComponent} from '../texts/texts.component';
import {Card} from '../../../model/cards';
import {IconComponent} from '../icon/icon.component';
import {Icons} from '../../../model/icon';
import {Cloud} from '../../../model/cloud';
import {ThemeService} from '../../../services/theme.service';

@Component({
  selector: 'app-looped-slider',
  imports: [
    NgForOf,
    ImageSliderComponent,
    NgIf,
    TextsComponent,
    NgClass,
    IconComponent
  ],
  templateUrl: './looped-slider.component.html',
  styleUrl: './looped-slider.component.scss'
})
export class LoopedSliderComponent implements AfterViewInit, OnInit, OnChanges{
  constructor(public themeService: ThemeService) {}

  @Input() grid: number = 4.2;
  @Input() hotel: boolean = true;
  @Input() cards: Card[] = [];
  @Input() imagesCards: boolean = false;

  @Output() clickOn = new EventEmitter();

  @ViewChild('container', { static: false }) container!: ElementRef;
  @ViewChild('slider', { static: true }) slider!: ElementRef<HTMLDivElement>;

  private isDragging: boolean = false;
  private startX: number = 0;
  private startY: number = 0;
  private scrollLeft: number = 0;
  private offScrollBehavior: boolean = false;
  private isHorizontalScroll: boolean = false;

  items: Card[] = [];

  startingX: number = 0;
  startingY: number = 0;

  containerWidth: number = 0;

  initialPadding: number = 0;

  isMobile: boolean = false;

  lastWalk: number = 0;

  lastDel: number = 0;

  threshold: number = 0.2;

  topMargin: string = 'margin-top: 0.75rem; align-items: center;';
  middleMargin: string = 'margin: 0.75rem 0; align-items: center;';

  arrowWidth: string = 'width: 28px; height: 28px;';

  pattern: string[] = ['center', 'flex-end', 'center', 'center', 'center', 'flex-end', 'center', 'flex-start', 'center', 'flex-end', 'center', 'center'];

  ngAfterViewInit() {
    this.containerWidth = this.container?.nativeElement.children[0].offsetWidth;
    const we = this.containerWidth / this.grid;
    this.initialPadding = we * this.cards.length;
    this.slider.nativeElement.scrollTo({
      left: this.initialPadding,
      behavior: 'instant'
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['cards']) {
      this.cards = changes['cards'].currentValue;
    }
  }

  ngOnInit() {
    if (window.innerWidth < 769) {
      this.isMobile = true;
    }
    let reorderArr = this.shiftArray(this.cards.slice());
    let idx = 0;
    reorderArr.forEach((v, index) => {
      const css = 'align-items: ' + this.pattern[idx] + ';';
      v.cssStyle = (v.cssStyle ?? '') + css;
      v.position = index % 2 == 1 ? 'horizontal' : 'vertical';
      if (idx + 1 > this.pattern.length) {
        idx = 0;
      } else {
        idx++;
      }
    });
    this.items = structuredClone(reorderArr);
    this.items.unshift(...structuredClone(reorderArr));
    this.items.push(...structuredClone(reorderArr));
    if (window.innerWidth < 550) {
      this.topMargin = 'margin-top: 0.25rem; align-items: center;'
      this.middleMargin = 'margin: 0.25rem 0; align-items: center;';
      this.arrowWidth = 'width: 12px; height: 12px;';
    }
  }

  @HostListener('mousedown', ['$event'])
  onMouseDown(event: MouseEvent) {
    event.preventDefault();
    this.offScrollBehavior = true;
    this.isDragging = true;
    this.isHorizontalScroll = false;
    this.startX = event.pageX - this.slider.nativeElement.offsetLeft;
    this.scrollLeft = this.slider.nativeElement.scrollLeft;
    if (this.scrollLeft == 0) {
      this.scrollLeft = this.initialPadding;
    }
  }

  @HostListener('touchstart', ['$event'])
  onTouchStart(event: TouchEvent) {
    this.startingX = event.touches[0].clientX;
    this.startingY = event.touches[0].clientY;
    this.offScrollBehavior = true;
    this.isDragging = true;
    this.isHorizontalScroll = false;
    this.startX = event.touches[0].pageX - this.slider.nativeElement.offsetLeft;
    this.startY = event.touches[0].pageY - this.slider.nativeElement.offsetLeft;
    this.scrollLeft = this.slider.nativeElement.scrollLeft;
  }

  @HostListener('mousemove', ['$event'])
  onMouseMove(event: MouseEvent) {
    if (!this.isDragging) return;
    event.preventDefault();
    const x = event.pageX - this.slider.nativeElement.offsetLeft;
    const walk = (x - this.startX);
    this.lastWalk = walk;
    this.slider.nativeElement.scrollLeft = this.scrollLeft - walk;
    this.isHorizontalScroll = true;
  }

  @HostListener('touchmove', ['$event'])
  onTouchMove(event: TouchEvent) {
    if (!this.isDragging) return;
    const deltaX = event.touches[0].clientX - this.startingX;
    const deltaY = event.touches[0].clientY - this.startingY;
    if (Math.abs(deltaX) > Math.abs(deltaY)) {
      event.preventDefault();
      this.isHorizontalScroll = true;
      const x = event.touches[0].pageX - this.slider.nativeElement.offsetLeft;
      const walk = (x - this.startX);
      this.lastWalk = walk;
      this.slider.nativeElement.scrollLeft = this.scrollLeft - walk;
    } else {
      this.isHorizontalScroll = false;
    }
  }
  @HostListener('wheel', ['$event'])
  onWheel(event: WheelEvent) {
    if (Math.abs(event.deltaX) > Math.abs(event.deltaY)) {
      event.preventDefault();
    }
  }

  @HostListener('mouseup')
  onMouseUp() {
    this.offScrollBehavior = false;
    setTimeout(() => {
      this.scrollToNearest();
    }, 50);
  }

  @HostListener('touchend')
  onTouchEnd() {
    this.offScrollBehavior = false;
    setTimeout(() => {
      this.scrollToNearest();
    }, 50);
  }

  @HostListener('mouseleave')
  onMouseLeave() {
    this.offScrollBehavior = false;
    setTimeout(() => {
      this.scrollToNearest();
    }, 50);
  }

  scrollToNearest() {
    const sl = this.slider.nativeElement.scrollLeft;
    const we = this.containerWidth / this.grid;
    const x = sl % we;
    const y = x > (we / 2);
    const u = Math.floor(sl/we) * we;
    this.slider.nativeElement.scrollLeft = y ? u + we : u;
    setTimeout(() => {
      let del = 0;
      const step = this.lastWalk / (this.grid * we);
      if (this.threshold < Math.abs(step)) {
        if (step > 0) {
          del = -1;
        } else {
          del = 1;
        }
      } else {
        del = 0;
      }
      this.lastDel = del;
      if (del != 0) {
        if (del > 0) {
          const elementsToMove = this.items.splice(0, del);
          this.items = this.items.concat(elementsToMove);
          this.slider.nativeElement.scrollTo({
            left: this.slider.nativeElement.scrollLeft - we * del,
            behavior: 'instant'
          });
        } else {
          const elementsToMove = this.items.splice(del);
          this.items = elementsToMove.concat(this.items);
          this.slider.nativeElement.scrollTo({
            left: this.slider.nativeElement.scrollLeft + (we * Math.abs(del)),
            behavior: 'instant'
          });
        }
      }
      this.isDragging = false;
    }, 100);
  }

  shiftArray(arr: Card[]): Card[] {
    if (!arr || arr.length < 5) {
      return arr;
    }
    const firstPart = arr.slice(0, 4);
    const secondPart = arr.slice(4);
    return [...secondPart, ...firstPart];
  }

  sliderClass(){
    return !this.offScrollBehavior ? 'slider-scroll-behavior' : '';
  }

  slideStyle(flex?: string) {
    if (flex) {
      return `min-width: calc(${(100 / this.grid)}%); display: flex;` + flex;
    } else {
      return `min-width: calc(${(100 / this.grid)}%);`
    }
  }

  isCloud(slide: Card) {
    return slide.cloud &&
      ((slide.cloud.title[0].length > 0 && slide.cloud.title[1].length > 0) ||
        (slide.cloud.textEn1 || slide.cloud.textEn2 || slide.cloud.textEn3));
  }

  openWhatsApp() {
    const phoneNumber = '+66991609711';
    const message = 'тест';
    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

    window.open(url, '_blank');
  }

  openLink(link: string) {
    if (link === 'whatsapp') {
      this.openWhatsApp();
    }
  }

  getInvert() {
    return this.themeService.getTheme() == 'black-theme';
  }

  protected readonly Icons = Icons;
}
